import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

interface Layout {
  canScroll: boolean;
}

const initialState = {
  canScroll: true,
} as Layout;

export const layoutSlice = createSlice({
  name: 'layout',
  initialState: initialState,
  reducers: {
    canScroll: (state, action: PayloadAction<boolean>) => {
      state.canScroll = action.payload;

      if (state.canScroll) {
        document.body.classList.remove('scroll-disable');
      } else {
        document.body.classList.add('scroll-disable');
      }
    },
  },
});

export const { canScroll } = layoutSlice.actions;

export const layout = (state: RootState) => state.layout;

export default layoutSlice.reducer;
